import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';

const DOCUMENTATION_FIELDS = {
    URL: {
        key: 'url',
        type: FIELD_TYPES.LINK
    }
};

export default DOCUMENTATION_FIELDS;